var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$getPermission(_vm.$route.path + '/project-delete') && !_vm.project.isParent)?_c('div',{staticClass:"button",on:{"click":_vm.deleteProject}},[_c('a-icon',{staticStyle:{"font-size":"16px","margin-bottom":"8px"},attrs:{"type":"delete"}}),_c('span',[_vm._v("删除")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }